<template>
	<div class="muster-panel" v-bind:class="{ active: side_panel == 'muster' }" v-if="event" >
		<a href="#" @click.prevent="side_panel = 'main'" class="btn btn-light border border-dark panel-close-btn">Back to List</a>
		<a href="#" @click.prevent="muster=false" class="btn btn-secondary font-md float-right" v-bind:class="{'disabled': !muster}">End Muster</a>
		<h1 class="text-center mt-2" v-bind:class="{ 'text-danger': event.status != 'done', 'text-success': event.status == 'done'}">{{ moment().hour(0).minute(0).second(stopwatch).format("HH:mm:ss") }}</h1>
		<hr>
		<h5 class="">Workers in muster zone:</h5>
		<ol>
			<transition-group name="fade">
				<li v-for="(rec, key) in workers_in" v-bind:key="key + 0">
					{{ rec.first_name }} {{ rec.last_name }}

				</li>
			</transition-group>
		</ol>

	</div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {
		name: 'MusterPanel',
		data() {
			return {
				event_id: null,
				event: null,
				workers_in: [],
				stopwatch: 0,
			}
		},
		watch: {
			muster: {
				handler() {
					if (this.muster) {
						this.event = this.log[this.muster];
						this.side_panel = 'muster';
						this.stopwatch = 0;
					}
					else if(this.event) {
						this.cancelMuster(this.event.id);
					}
				},
				immediate: true
			},
			workers: {
				handler() {
					if (!this.event) return;

					for (let i in this.workers) {

						let worker = this.workers[i];
						if (worker.status == 'at-zone' && worker.zone.type == 'muster') {
							let added = false;
							for (let k in this.workers_in) {
								if (this.workers_in[k].id == i) added = true;
							}
							if (!added) this.workers_in.push(this.workers[i]);
						}
					}

					if (this.workers_in.length == Object.keys(this.workers).length) {
						this.event.status = 'done';
						this.event.end = this.time;
					}
				},
				deep: true,
				immediate: true
			},
			time: {
				handler() {
					if (this.event && this.event.status != 'done') {
						this.stopwatch = this.event.stopwatch = this.time - this.event.time;
					}
				},
				immediate: true
			},
		},
		computed: {
			...mapState([
				'day',
				'alert ',
				'workers',
				'watcher',
				"worker_status",
				'time',
			]),
			end_time() { return this.$config.end_time},
			worker_types() { return this.$config.worker_types },
			log: {
				get() {
					return this.$store.state.log
				},
				set(value) {
					this.$store.commit('add_log', value)
				}
			},
			muster: {
				get() {
					return this.$store.state.muster
				},
				set(value) {
					this.$store.commit('setState', ['muster', value])
				}
			},
			side_panel: {
				get() { return this.$store.state.side_panel },
				set(value) { this.$store.commit('setState', ['side_panel', value])}
			},
			zones() { return this.$store.state.zones},
		},
		methods: {
			cancelMuster(parent_id) {
				//if (this.muster == false) return

				this.muster = false;
				let status = this.event.status == 'done' ? 'end' : 'cancelled';
				let event_id = this.$finder.next_id(this.log);
				let event = {type: 'muster', time: this.time, id: event_id, parent_id: parent_id, day: this.day};
				this.$set(this.log, event_id, event);

				this.event = null;
				this.event_id = null;
				this.stopwatch = 0;

				this.workers_in = [];

				this.log[parent_id].status = status;
				this.log[parent_id].end = this.time;

				this.side_panel = 'main'
			},

		}
	}
</script>
